import * as React from "react";
import styles = require("./style.less");
import { FormSectionBase, FormSectionBaseProps } from "components/form/Sections/FormSectionBase";

class UnstructuredFormSection extends FormSectionBase<FormSectionBaseProps> {
    render() {
        return <div className={styles.formNonExpander}>
            {this.body(styles.cardMediaNonExpander, false)}
        </div>;
    }
}

export default UnstructuredFormSection;
